import _ from 'lodash'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { selectors } from '../../imports'
import { isMenuOpen, closeMenu } from '../../data'
import Menu from './component'

const getInactiveServers = createSelector(
    [
        selectors.getServers,
        selectors.getTestServers,
        selectors.getLocale,
        selectors.getActiveServerId,
    ],
    (allServers, testServers, locale, activeId) => {
        // Now we only want servers that are in testServers or tq
        const servers = _.reduce(
            allServers,
            (result, server, serverId) => {
                // We skip the active server
                if (serverId === activeId) return result

                // We add chinese servers, tq, and all test servers
                if (locale === 'zh' || serverId === 'tq' || testServers.indexOf(serverId) > -1) {
                    result.push(serverId)
                }

                return result
            },
            [],
        )
        // And now we throw out the active server
        return _.without(servers, activeId)
    },
)

function mapStateToProps(state) {
    const activeId = selectors.getActiveServerId(state)
    const inactiveServers = getInactiveServers(state)

    return {
        noMenu: inactiveServers.length < 1,
        isOpen: isMenuOpen(state),
        activeServerId: activeId,
        inactiveServers,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        closeMenu: () => {
            dispatch(closeMenu())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu)



// WEBPACK FOOTER //
// ./src/features/ServerMenu/components/Menu/index.js